export const LEN_HIOS_PLAN_ID_WITH_VARIANT = 17;
export const LEN_HIOS_PLAN_ID = 14;
export const PLAN_INITIAL_INDEX = 0;
export const PATTERN_HIOS_PLAN_NUM_WITH_VARIANT = new RegExp('(^[A-Za-z0-9]{5})([A-Za-z]{2})([0-9]{7})([\\\\-]{1})([0]{1}[0-6]{1})+$'); // Example -> 32561MN9876543-04
export const PATTERN_HIOS_PLAN_NUM = new RegExp('(^[A-Za-z0-9]{5})([A-Za-z]{2})([0-9]{7})$'); // Example -> 32561MN9876543
export const FEATURE_PLAN_UPLOAD_STATUS = {
    SUCCESS: 'Success',
    FAILURE: 'Failure',
};
export const COLUMN_LENGTH = 50;
export const PAGINATION_THRESHOLD = 10;
export const SUFFIXES = {
    BENEFITS_SUFFIX: 'plans.xml',
    DRUG_SUFFIX: 'drug.xml',
    NETWORK_SUFFIX: 'network.xml',
    RATE_SUFFIX: 'rate.xml',
    SERVICE_AREA_SUFFIX: 'servicearea.xml',
    BUSINESS_RULE_SUFFIX: 'businessrule.xml',
    UNIFIED_RATE_SUFFIX: 'urrt.xml',
};

